module.exports = __webpack_public_path__ + "./images/7988f3f7cfb82f45da0a577382c0aeae.webp";